"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogClassNameContext = void 0;
const react_1 = require("react");
// To pass theme css variables to portal
exports.DialogClassNameContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWFsb2cvY29udGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxpQ0FBc0M7QUFFdEMsd0NBQXdDO0FBQzNCLFFBQUEsc0JBQXNCLEdBQUcsSUFBQSxxQkFBYSxFQUNqRCxTQUFTLENBQ1YsQ0FBQyJ9